<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3> {{ label.get('location_tracking') }}</h3>
      </div>
      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('preference') }}</label>
          </div>
          <div class="action-buttons" v-if="saveChangesEnabled">
            <button
                class="update-btn cancel"
                type="button"
                @click="cancel"
            >
              <i class="atto atto-close-btn" />
              {{label.get('cancel')}}
            </button>
            <button
                class="update-btn save-changes"
                type="button"
                :disabled="disabledSubmitButton"
                @click="saveChanges"
            >
              <i class="atto atto-selected-tick" />
              {{label.get('save_changes')}}
            </button>
          </div>
        </div>
        <div class="content-wrapper location-tracking-preference">
          <div class="check-wrapper">
            <b-form-radio
                class="radio-style"
                v-model="locationTracking"
                name="location_tracking"
                :value="LOCATION_TRACKING_ALWAYS"
            >
              {{ label.get('while_on_the_clock') }}
              <p>{{ label.get('while_on_the_clock_description') }}</p>
            </b-form-radio>

          </div>

          <div class="check-wrapper">
            <b-form-radio
                class="radio-style"
                v-model="locationTracking"
                name="location_tracking"
                :value="LOCATION_TRACKING_WHILE_USING"
            >
              {{ label.get('on_clock_in_out') }}
              <p>{{ label.get('on_clock_in_out_description') }}</p>
            </b-form-radio>

          </div>

          <div class="check-wrapper">
            <b-form-radio
                class="radio-style"
                v-model="locationTracking"
                name="location_tracking"
                :value="LOCATION_TRACKING_NONE"
            >
              {{ label.get('never') }}
              <p>{{ label.get('no_location_permissions_description') }}</p>
            </b-form-radio>
          </div>
        </div>
      </div>
      <div class="white-card requirements" v-if="locationTracking !== 0">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get('requirements') }}</label>
          </div>
          <div class="action-buttons" v-if="saveRequirementsChangesEnabled">
            <button
                class="update-btn cancel"
                type="button"
                @click="cancelRequirementsChanges"
            >
              <i class="atto atto-close-btn" />
              {{label.get('cancel')}}
            </button>
            <button
                class="update-btn save-changes"
                type="button"
                :disabled="disabledSubmitButton"
                @click="saveRequirementsChanges"
            >
              <i class="atto atto-selected-tick" />
              {{label.get('save_changes')}}
            </button>
          </div>
        </div>
        <div class="content-wrapper">
          <div class="check-wrapper switch-wrapper">
            <b-form-checkbox
                v-model="specificTrackingPermission"
                @change="toggleSpecificTracking"
            >
              {{ label.get('location_tracking_user_specific_tracking_permissions') }}
            </b-form-checkbox>
            <p class="disclaimer">
              {{ label.get('location_tracking_user_specific_tracking_permissions_description') }}
            </p>
          </div>
        </div>

        <div
            v-if="specificTrackingPermission"
            class="list-container requirements-list"
        >
          <div class="table-heading">
            <span class="heading-label member-name">{{ label.get('name') }}</span>
            <span class="heading-label tracking">{{ label.get('location_tracking') }}</span>
          </div>
          <ul class="team-members">
            <li
                v-for="(member, idx) in memberTracked"
                :key="idx"
                :class="{disabled: !specificTrackingPermission}"
            >
              <div class="pic-wrap">
              <span
                  v-if="!member.avatar"
                  class="initials"
              >{{ member.initials }}</span>
                <img
                    v-if="member.avatar"
                    :src="member.avatar"
                    width="40"
                    height="40"
                    class="member-pic"
                >
              </div>
              <div class="member-wrap">
                <h4 class="member-name">
                  {{ member.name }}
                </h4>
              </div>
              <div class="tracking-status tracking">
                <div class="check-wrapper">
                  <b-form-checkbox
                      v-model="member.user_settings.location_tracking_enabled"
                      :disabled="!specificTrackingPermission"
                      @change="toggleUserLocationTracking(member)"
                  >
                    {{ label.get('required') }}
                  </b-form-checkbox>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import LocationTrackingServices from "./services/LocationTrackingService";

    export default {
        name: "LocationTrackingComponent",
        filters: {
            getInitials(memberName){
                let names = memberName.split(' '),
                    initials = names[0].substring(0, 1).toUpperCase();

                if (names.length > 1) {
                    initials += names[names.length - 1].substring(0, 1).toUpperCase();
                }
                return initials;
            }
        },
        data() {
            return {
                LOCATION_TRACKING_NONE: 0,
                LOCATION_TRACKING_ALWAYS: 1,
                LOCATION_TRACKING_WHILE_USING: 2,
                locationTracking: this.$store.state.companySettings.location_tracking,
                userLocationTracking: null,
                specificTrackingPermission: this.$store.state.companySettings.allow_specific_permission,
                requiredLocationTracking: false,
                memberTracked: this.$store.state.members,
                debounce: null,
                saveChangesEnabled: false,
                saveRequirementsChangesEnabled: false,
                disabledSubmitButton: true
            }
        },
        watch: {
          locationTracking(newVal, oldVal) {
            if(newVal !== this.$store.state.companySettings.location_tracking) {
              this.saveChangesEnabled = true;
              this.disabledSubmitButton = false;
            } else {
              this.saveChangesEnabled = false;
              this.disabledSubmitButton = true;
            }
          }
        },
        created(){
            this.getMemberList();
        },
        methods: {
            toggleSpecificTracking() {
              this.disabledSubmitButton = false;
              this.saveRequirementsChangesEnabled = true;
                const _this = this;
                this.$store.state.companySettings.allow_specific_permission = !_this.specificTrackingPermission;

               /* const companySettings = _this.$store.state.companySettings;
                _this.debounce = setTimeout(() => {
                    LocationTrackingServices.updateCompanySettings(companySettings).then((result) => {
                        this.$awn.success(result.data.message);
                        this.$store.state.companySettings = companySettings;
                        this.saveRequirementsChangesEnabled = true;
                        /!*this.saveChangesEnabled = true;*!/
                    }).catch(() => {
                    })
                }, 300);*/
            },
            getMemberList() {
                const _this = this;
                this.$store.commit('showLoading');
                LocationTrackingServices.getMembersWithSettings().then((result) => {
                    _this.memberTracked = result.members;
                    this.$store.commit('hideLoading');
                }).catch((error) => {
                    this.$store.commit('hideLoading');
                });
            },
            toggleUserLocationTracking(member) {
                const _this = this;
                if(_this.debounce){
                    clearTimeout(_this.debounce);
                }

                let data = {
                    user_id: member.id,
                    location_tracking_enabled: !member.user_settings.location_tracking_enabled
                };

                _this.debounce = setTimeout(() => {
                    LocationTrackingServices.updateMemberLocationTracking(data).then((result) => {
                        this.$store.state.members = this.memberTracked;

                    }).catch(() => {
                    });
                }, 300);
            },
            saveChanges(){
              this.disabledSubmitButton = true;
              this.$store.state.companySettings.location_tracking = this.locationTracking;
              if(this.locationTracking === this.LOCATION_TRACKING_NONE) {
                this.$store.state.companySettings.allow_specific_permission = false;
              }
             /* if(this.locationTracking === this.LOCATION_TRACKING_WHILE_USING) {
                this.$store.state.companySettings.allow_specific_permission = this.toggleSpecificTracking;
              }*/

              const _this = this;
              if(_this.debounce){
                clearTimeout(_this.debounce);
              }
              const companySettings = _this.$store.state.companySettings;
              _this.debounce = setTimeout(() => {
                LocationTrackingServices.updateCompanySettings(this.$store.state.companySettings, companySettings).then((result) => {
                  this.$awn.success(result.data.message);
                  this.$store.state.companySettings = companySettings;
                  this.saveChangesEnabled = false;
                }).catch(() => {
                })
              }, 300);
            },
            saveRequirementsChanges() {
              this.disabledSubmitButton = false;
              const _this = this;
              debugger;
              const companySettings = _this.$store.state.companySettings;
              if(_this.debounce){
                clearTimeout(_this.debounce);
              }
              _this.debounce = setTimeout(() => {
                LocationTrackingServices.updateCompanySettings(companySettings).then((result) => {
                  this.$awn.success(result.data.message);
                  this.$store.state.companySettings = companySettings;
                  this.saveRequirementsChangesEnabled = false;
                  /*this.saveChangesEnabled = true;*/
                }).catch(() => {
                })
              }, 300);
            },
            cancelRequirementsChanges() {
              const _this = this;
              _this.specificTrackingPermission = !this.$store.state.companySettings.allow_specific_permission ;
              this.saveRequirementsChangesEnabled = false;
            },
            cancel(){
              this.locationTracking = this.$store.state.companySettings.location_tracking;
              this.saveChangesEnabled = false;
            }
        }
    }
</script>

<style lang="scss">
  .check-wrapper .custom-checkbox .custom-control-label::before{
    border-radius: 0;
    background-color: #ffffff;
  }

    .table-heading {
        .tracking {
            width: 340px;
            margin-left: auto;
            margin-right: 0 !important;
        }
    }

    .toggle-dep {
        &.no-border {
            border-bottom: 0;
        }
    }

    h4.section-headtitle.pushed{
        padding: 0 80px;
    }

    .requirements-list{
      &.list-container{
        .table-heading {
          padding: 5px 16px 6px 20px !important;
          .member-name{
            min-width: 238px;
            width: 31.3%;
            margin-left: 44px;
          }
          .tracking{
            margin-left: 0;
          }
        }

        ul.team-members {
          li {
            height: 50px;
            padding: 7px 16px;
            border-bottom: none;
            border-top: 1px solid $atto-light-grey;
            .pic-wrap{
              width: 36px;
              height: 36px;
              margin-right: 12px;
              img{
                width: 36px;
                height: 36px;
              }
              span{
                &.initials{
                  width: 36px;
                  height: 36px;
                }
              }
            }
            .member-wrap{
              min-width: 220px;
              width: 30%;
              .member-name{
                font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
              }
            }
            .tracking-status {
              min-width: 340px;
              width: 30%;
              /* margin-left: auto;*/

              .check-wrapper .custom-checkbox .custom-control-label {
                font-weight: 400;
                padding-left: 10px;
                font-size: 0.875rem;
                line-height: 1.5rem;
              }
            }

            &.disabled{
              .pic-wrap{
                span.initials{
                  background-color: $atto-grey;
                  color: $atto-dark-grey;
                  width: 36px;
                  height: 36px;
                }
              }
              .member-wrap{
                .member-name{
                  color: $atto-dark-grey;
                }
              }

              .check-wrapper{
                .custom-checkbox{
                  .custom-control-input:checked ~ .custom-control-label::after{
                    color: $atto-light-grey;
                    /*color: #fff;*/
                  }

                  .custom-control-input:checked ~ .custom-control-label::before{
                    background-color: #fff;
                    border-color: $atto-light-grey;
                  }
                }
              }
            }

            &:hover{
              background-color: $atto-grey;
            }
          }
        }
      }
    }


    .location-tracking-preference{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .check-wrapper{
        width: 34%;

      /*  .radio-style.custom-checkbox .custom-control-label{
         font: $roboto-regular 0.9375rem/1.75rem $roboto-font;
        }*/
        .custom-radio {
          .custom-control-label{
            display: flex;
            flex-flow: column;
            font-size: 0.9375rem;
            line-height: 1.75rem;
            font-weight: $roboto-regular;
          }
        }
      }
      p{
        margin: 4px 0 0 0;
        padding-left: 0;
        color: #666666;
        font: $roboto-regular 0.875rem/1.25rem $roboto-font;
        max-width: 240px;
      }
    }
    .requirements {
      .switch-wrapper.check-wrapper .custom-checkbox .custom-control-label{
        text-transform: unset;
      }
      p.disclaimer{
        margin-top: 4px;
        color: #666666;
        max-width: 450px;
      }
    }

</style>
